import { gql } from "@apollo/client";

export const GET_CRE_LINKS = gql`
  query GetCreLinks($input: CreLinksInput!) {
    creLinks(input: $input) {
      links {
        id
        sourceType
        sourceId
        targetType
        targetId
        role
        confidence
        origin
        updatedAt
      }
    }
  }
`;
